import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "regenerator-runtime/runtime.js";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, onMounted, reactive, ref, onUnmounted } from "vue";
import { useStore } from "vuex";
import staticData from "@/assets/data/dataScreen.json";
export default defineComponent({
  name: "Meeting",
  components: {},
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var store = useStore();
    var Data = reactive({
      tableData: []
    });
    var total = ref(0);
    var missionNum = ref(0);
    var inspectionLineHtmlMeeting = ref();
    var inspectionLineHtmlMeetingWidth = ref();
    var timer = ref();
    var meetingTimer1;
    onMounted(function () {
      if (store.state.system.demonstration) {
        Data.tableData = staticData.meetingData;
        total.value = 25;
        setLine();
        meetingTimer1 = setTimeout(function () {
          startMeeting();
          clearTimeout(meetingTimer1);
        }, 2000);
      } else {
        getList();
        meetingTimer1 = setTimeout(function () {
          startMeeting();
          clearTimeout(meetingTimer1);
        }, 2000);
        taskGetMeeting();
      }
    });

    var getList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getMeetingDataScreen();

              case 2:
                _context.next = 4;
                return getmeetingDataScreenTotal();

              case 4:
                setLine();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getList() {
        return _ref.apply(this, arguments);
      };
    }(); //绘制线下会议的横条


    function setLine() {
      var missionTimer = setTimeout(function () {
        inspectionLineHtmlMeeting.value = document.querySelectorAll(".inspectionLineMeeting");
        inspectionLineHtmlMeetingWidth.value = document.getElementsByClassName("inspectionNumberMeeting");
        var maxWidth = inspectionLineHtmlMeetingWidth.value[0].offsetWidth;
        var maxValue = 0;
        var fontNum = 0;

        if (inspectionLineHtmlMeeting.value) {
          Data.tableData.forEach(function (item) {
            if (Number(item.total) > maxValue) {
              maxValue = Number(item.total);
              fontNum = item.total.length;
            }
          });
          Data.tableData.forEach(function (item) {
            var len = inspectionLineHtmlMeeting.value.length;

            for (var i = 0; i < len; i++) {
              var dataset = inspectionLineHtmlMeeting.value[i].dataset;

              if (dataset.linenum == item.id) {
                inspectionLineHtmlMeeting.value[i].style.width = Number(item.total) / maxValue * (maxWidth - fontNum * 14) + "px";
              }
            }
          });
        }

        clearTimeout(missionTimer);
      }, 0);
    }

    function testMoveMeeting() {
      clearInterval(timer.value);
    }

    function testMendMeeting() {
      startMeeting();
    }

    function startMeeting() {
      //清除定时器
      clearInterval(timer.value); //定时器触发周期

      var speed = ref(50);
      timer.value = setInterval(MarqueeTestMeeting, speed.value);
    }

    var rollHtmlMeeting = ref();

    function MarqueeTestMeeting() {
      rollHtmlMeeting.value = document.getElementsByClassName("rollMeeting");
      var test1 = rollHtmlMeeting.value[0];

      if (test1 && test1.offsetHeight == 0) {
        test1 = rollHtmlMeeting.value[0];
      } else {
        //如果列表数量过少不进行滚动
        if (test1 && test1.children.length < 8) {
          clearInterval(timer.value);
          return;
        }

        test1.scrollTop += 1;

        if (test1.scrollTop == test1.scrollHeight - test1.clientHeight) {
          var a = test1.children[0];
          test1.removeChild(a);

          if (Data.tableData.length % 2 == 1) {
            a.className = a.className == "bot-bot" ? "blue bot-bot" : "bot-bot";
          }

          test1.append(a);
        }
      }
    }

    function testMoveMeetingLine(res) {
      missionNum.value = res.total;
      Data.tableData.forEach(function (item) {
        if (item.id == res.id) {
          item.show = true;
        }
      });
    }

    function testMendMeetingLine(res) {
      Data.tableData.forEach(function (item) {
        if (item.id == res.id) {
          item.show = false;
        }
      });
    }

    var timerMM;

    var taskGetMeeting = function taskGetMeeting() {
      timerMM = setInterval(function () {
        getList(); // clearInterval(timerMM);
        // taskGetMeeting();
      }, 10000);
    };

    onUnmounted(function () {
      //清除轮训定时器
      clearInterval(timerMM); //清除滚动的定时器

      clearInterval(timer.value);
      clearTimeout(meetingTimer1);
    }); // 线下会议

    var getMeetingDataScreen = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMeetingDataScreen"]();

              case 2:
                res = _context2.sent;

                if (res.code == 0) {
                  Data.tableData = res.data;
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getMeetingDataScreen() {
        return _ref2.apply(this, arguments);
      };
    }(); //总数


    var getmeetingDataScreenTotal = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getmeetingDataScreenTotal"]();

              case 2:
                res = _context3.sent;

                if (res.code == 0) {
                  total.value = res.data;
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getmeetingDataScreenTotal() {
        return _ref3.apply(this, arguments);
      };
    }();

    return {
      Data: Data,
      total: total,
      missionNum: missionNum,
      inspectionLineHtmlMeeting: inspectionLineHtmlMeeting,
      rollHtmlMeeting: rollHtmlMeeting,
      testMoveMeeting: testMoveMeeting,
      testMendMeeting: testMendMeeting,
      testMoveMeetingLine: testMoveMeetingLine,
      testMendMeetingLine: testMendMeetingLine,
      getList: getList,
      getmeetingDataScreenTotal: getmeetingDataScreenTotal,
      getMeetingDataScreen: getMeetingDataScreen,
      setLine: setLine
    };
  }
});